export const ServiceTokens = Object.freeze({
    VueRouter: 'VueRouter',
    BaseStore: 'BaseStore',
    UserDetailsStoreService: 'UserDetailsStoreService',
    OpenInAppStoreService: 'OpenInAppStoreService',
    MobileModeStoreService: 'MobileModeStoreService',
    PlatformResolutionService: 'PlatformResolutionService',
} as const);
